<template>
  <div class="p-templates g-page">
    <div slot="row">
      <VLowEnvelopeAllowanceWarning ec="templates" />
      <div class="inline-flex gap-base justify-between justify-right controls-right w-full mb-base flex-wrap-reverse">
        <div class="flex-grow">
          <VSearch
              class="flex-grow float-none"
              placeholder="Search Templates"
              data-test="contacts-search"
              et="envelope_send"
              @onSearch="onSearch"
              @onResetSearch="onResetSearch"
              data-ec="templates"
              data-et="search_templates"
          />
        </div>
        <VButton
            type="cta-1"
            class="float-none whitespace-nowrap"
            :action="openCreateModal"
            data-ec="templates"
            data-et="new_template_top"
            data-test="button-new-template"
        >
          <PlusIcon />
          <span>{{ $t('templates.newTemplate') }}</span>
        </VButton>
      </div>
      <div class="p-templates__no-templates" v-if="!$store.getters['templates/pagedResults'].length">
        <span class="p-templates__no-templates__text p-templates__no-templates__horizontal-align">{{ $t('templates.messageNoTemplates') }}</span>
        <img class="p-templates__no-templates__image" src="../assets/no_result_dog.svg" :alt="$t('templates.altImageMessage')">
        <div class="p-templates__no-templates__horizontal-align">
          <span class="p-templates__no-templates__text p-templates__no-templates__text__bottom">{{ $t('templates.messageAddOneNow') }}</span>
        </div>
      </div>
      <div :title="$t('functional.viewSwitcherButtonOptions.cardView')" icon="file">
        <div v-if="!$store.getters['templates/hasLoaded']">
          <VLoadingSpinner size="large" />
        </div>
        <VGrid v-else>
          <div
            v-for="(template, index, key) in templates"
            slot="gridItem"
            type="3"
            ratio="1.4"
            :key="key">
            <RouterLink
              :to="{ name: 'Template', params: {'templateId': template.fingerprint} }"
              data-ec="templates"
              data-et="template_card">
              <VCard
                :title="template.title"
                :date="template.created_at"
                :imageSrc="template.images[0]"
                data-hj-suppress />
            </RouterLink>
          </div>
        </VGrid>
      </div>
      <SElPagination
          v-if="totalPages"
          class="p-document-selection-form__paginate"
          :pager-count="5"
          @current-change="handlePageChange"
          :page-count="totalPages"
          :current-page.sync="meta.current_page" />
    </div>
      <div class="g-page__row">
        <PageResultsCounter
          v-if="resultsMeta && totalCount"
          :from="resultsMeta.from"
          :to="resultsMeta.to"
          :total="totalCount"
          :type="$t('functional.templates')" />
      </div>
    <VDynamicLoader viewURL="modals/template/Create" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import VButton from '@/components/deprecated/atoms/Button.vue';
import VLoadingSpinner from '@/components/deprecated/atoms/LoadingSpinner.vue';
import VCard from '@/components/deprecated/molecules/Card.vue';
import VGrid from '@/components/deprecated/organisms/Grid.vue';
import VSearch from '@/components/deprecated/organisms/Search.vue';
import PageResultsCounter from '@/views/components/PageResultsCounter.vue';
import VLowEnvelopeAllowanceWarning from '@/views/components/LowEnvelopeAllowanceWarning.vue';
import TemplateSearch from '@/mixins/templateSearch';
import SElPagination from '@/views/components/SElPagination.vue';
import { logAmplitudeEvent } from '@/utils/analytics';
import VDynamicLoader from '@/components/DynamicLoader.vue';
import { PlusIcon } from '@/components/icons/fontIcons';

export default {
  name: 'TemplatesView',
  components: {
    VCard,
    VButton,
    VLoadingSpinner,
    VGrid,
    VSearch,
    SElPagination,
    VLowEnvelopeAllowanceWarning,
    PageResultsCounter,
    VDynamicLoader,
    PlusIcon,
  },
  data() {
    return {};
  },
  mixins: [TemplateSearch],
  computed: {
    ...mapGetters({
      hasLoaded: 'templates/hasLoaded',
      templates: 'templates/pagedResults',
      resultsMeta: 'templates/meta',
      totalCount: 'templates/totalCount',
      totalPages: 'templates/totalPages',
      currentPage: 'templates/currentPage',
      meta: 'templates/meta',
    }),
    responsiveNoOfPages() {
      return (screen.width > 666) ? 24 : 8; // eslint-disable-line
    },
  },
  created() {
    this.templateData.page = this.$route.params.pageNumber || 1;
    this.templateData.query = this.$route.query.q;
    this.templateData.pageLimit = this.responsiveNoOfPages;
    this.getTemplates();
  },
  methods: {
    handlePageChange(page) {
      this.templateData.page = page;
      this.getTemplates();
      this.updateRoute(page);
    },
    onSearch({ value }) {
      // Only perform the search if the query string parameter has changed
      if (this.$route.query.q !== this.templateData.query) {
        const currentPage = this.templateData.page;
        this.templateData.query = value;
        this.templateData.page = 1;
        this.getTemplates();
        logAmplitudeEvent('templates-search-searched');
        if (currentPage !== '1' && currentPage !== 1) this.updateRoute(1);
      }
    },
    onResetSearch() {
      const currentPage = this.templateData.page;
      this.templateData.query = null;
      this.templateData.page = 1;
      this.getTemplates();
      logAmplitudeEvent('templates-search-reset');
      if (currentPage !== '1' && currentPage !== 1) this.updateRoute(1);
    },
    updateRoute(page) {
      const query = {};
      if (this.templateData.query) query.q = this.templateData.query;
      this.$router.push({
        name: 'Templates',
        params: {
          pageNumber: page,
        },
        query,
      });
      logAmplitudeEvent('templates-route-update');
    },
    openCreateModal() {
      logAmplitudeEvent('templates-template-create-modal-opened');
      this.$bus.$emit('toggleModal', { name: 'template-create-modal', active: true });
    },
    navigateToTemplateStatus($event) {
      logAmplitudeEvent('templates-template-status-navigate');
      const index = $event.currentTarget.getAttribute('data-id');
      const currentResults = this.$store.getters['templates/pagedResults'];
      const template = JSON.parse(JSON.stringify(currentResults[index]));
      this.$router.push({
        name: 'Template',
        params: {
          templateId: template.fingerprint,
        },
      });
    },
  },
};
</script>

<style scoped>
.m-card {
  min-height: 75px;
}

.p-templates__create-button {
  margin: 0 0 var(--spacing-base) var(--spacing-base);
}

.p-templates__no-templates {
  clear: both;
  text-align: center;
  margin-top: var(--spacing-base);
}

.p-templates__no-templates__image {
  width: 30%;
  margin-left: 35%;
}

.p-templates__no-templates__text {
  font-family: "Roboto Slab", serif !important;
  font-weight: 500 !important;
  margin-right: var(--spacing-base);
  font-size: 24px;
}

.p-templates__no-templates__text__bottom {
  line-height: 38px;
  display: inline-block;
}

.p-templates__no-templates__horizontal-align {
  text-align: center;
  display: inline-block;
}

.p-templates__no-templates__horizontal-align__button {
  float: right;
  display: inline-block;
}

.p-templates__float-right {
  float: right;
}

.p-templates__top-pagination {
  display: inline-block;
  margin-top: 0;
  margin-right: calc(50vw - 410px);
  margin-left: var(--spacing-base);
}

@media (max-width: 1020px) {
  .p-templates__top-pagination {
    margin-right: calc(50vw - 313px);
  }
}

@media (max-width: 760px) {
  .p-templates__top-pagination {
    display: block;
    margin-bottom: var(--spacing-base);
    margin-right: auto;
  }
  .p-templates__float-right {
    float: none;
  }
  .p-templates__create-button {
    order: 1;
  }
}

@media screen and (max-width: 478px) {
  .p-templates__no-templates__horizontal-align {
    display: block;
  }
  .p-templates__no-templates__horizontal-align__button {
    float: none;
  }
}
</style>
